import {
  PLATFORM_PROFILE_AA_TYPE,
  PLATFORM_PROFILE_TYPE,
  PLATFORM_TYPE,
} from "../../utils/constants";
import { getUrls } from "../../utils/urls";
import useApiWrapper from "./useApiWrapper";

const useAirlineAdminApi = (isAAUser) => {
  const { fetchWithAuth, downloadFileWithAuth } = useApiWrapper();
  const URLS = getUrls();

  const fetchCommercialUserProfile = async () => {
    return await fetchWithAuth(URLS.GET_COMMERCIAL_USER_PROFILE(isAAUser));
  };

  const fetchHistoricCommercialFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.GET_HISTORIC_COMMERCIAL_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const filterHistoricCommercialFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.FILTER_HISTORIC_COMMERCIAL_FLIGHT_PLANS(
        isAAUser
      )}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchCommercialFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.GET_COMMERCIAL_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchCommercialFlightPlan = async (flightPlanId) => {
    return await fetchWithAuth(
      `${URLS.GET_COMMERCIAL_FLIGHT_PLAN(flightPlanId, isAAUser)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const fetchCommercialFutureFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.GET_COMMERCIAL_FUTURE_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const filterCommercialFutureFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.FILTER_COMMERCIAL_FUTURE_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchCommercialCurrentFlightPlansSummary = async () => {
    return await fetchWithAuth(
      `${URLS.GET_COMMERCIAL_CURRENT_FLIGHT_PLANS_SUMMARY(isAAUser)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const filterCommercialCurrentFlightPlansSummary = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.FILTER_COMMERCIAL_CURRENT_FLIGHT_PLANS_SUMMARY(
        isAAUser
      )}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const filterCommercialFlightPlans = async (flightData) => {
    const queryParams = new URLSearchParams(flightData).toString();
    return await fetchWithAuth(
      `${URLS.FILTER_COMMERCIAL_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchCommercialFlightPlanFee = async (flightPlanId) => {
    return await fetchWithAuth(
      URLS.GET_COMMERCIAL_FLIGHT_PLAN_FEE(flightPlanId, isAAUser)
    );
  };

  const fetchCommercialFlightPlanApprovals = async (flightPlanId) => {
    return await fetchWithAuth(
      URLS.GET_COMMERCIAL_FLIGHT_PLAN_APPROVALS(flightPlanId)
    );
  };

  const fetchListOfAirport = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRPORT);
  };
  const fetchAARoles = async () => {
    return await fetchWithAuth(URLS.GET_AA_ROLES);
  };
  const fetchAirportById = async (airportId) => {
    return await fetchWithAuth(URLS.GET_AIRPORT_BY_ID(airportId));
  };
  const fetchListOfAirline = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRLINE);
  };

  const fetchListOfAssociatedAirline = async () => {
    return await fetchWithAuth(URLS.GET_AIRLINE_ME(isAAUser));
  };

  const fetchListOfAircraft = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRCRAFT);
  };

  const searchAircraft = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRCRAFT}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const searchAirport = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRPORT}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchAircraftDetails = async (aircraftTypeId) => {
    return await fetchWithAuth(URLS.GET_AIRCRAFT_DETAILS(aircraftTypeId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const createCommercialFlightPlan = async (flightData) => {
    return await fetchWithAuth(URLS.CREATE_COMMERCIAL_FLIGHT_PLANS(isAAUser), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(flightData),
    });
  };

  const checkOvertimeFee = async (feeData) => {
    const queryParams = new URLSearchParams(feeData).toString();
    return await fetchWithAuth(`${URLS.CHECK_OVERTIME_FEE}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const editCommercialFlightPlan = async (planId, flightData) => {
    return await fetchWithAuth(
      URLS.EDIT_COMMERCIAL_FLIGHT_PLANS(planId, isAAUser),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(flightData),
      }
    );
  };

  const cancelCommercialFlightPlan = async (planId) => {
    if (!planId) {
      throw new Error("Flight plan ID is missing.");
    }

    return await fetchWithAuth(
      URLS.CANCEL_COMMERCIAL_FLIGHT_PLANS(planId, isAAUser),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const approveAACommercialFlightPlan = async (planId) => {
    return await fetchWithAuth(
      URLS.APPROVE_AA_COMMERCIAL_FLIGHT_PLANS(planId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const approveAirlineCommercialFlightPlan = async (planId) => {
    return await fetchWithAuth(
      URLS.APPROVE_AIRLINE_COMMERCIAL_FLIGHT_PLANS(planId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const checkAirlineApprovalDispute = async (
    planId,
    raiseDispute = false,
    disputeReason = ""
  ) => {
    return await fetchWithAuth(
      URLS.CHECK_AIRLINE_APPROVAL_DISPUTE(planId, raiseDispute, disputeReason),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };
  const editCommercialFlightPlanPassengers = async (planId, passengersData) => {
    return await fetchWithAuth(
      URLS.EDIT_COMMERCIAL_FLIGHT_PLANS_PASSENGERS(planId),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(passengersData),
      }
    );
  };

  const editCommercialFlightPlanVehicles = async (planId, vehiclesData) => {
    return await fetchWithAuth(
      URLS.EDIT_COMMERCIAL_FLIGHT_PLANS_VEHICLES(planId),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(vehiclesData),
      }
    );
  };

  const searchFlightPlan = async (planData) => {
    const queryParams = new URLSearchParams(planData).toString();
    return await fetchWithAuth(
      `${URLS.SEARCH_FLIGHT_PLANS(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getAirlineAssociation = async () => {
    return await fetchWithAuth(URLS.GET_AIRLINE_ASSOCIATIONS, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const getAllCommercialAirline = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRLINE);
  };

  const searchAirline = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRLINE}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchListOfCountry = async () => {
    return await fetchWithAuth(URLS.GET_COUNTRIES_LIST);
  };

  const fetchStateCityList = async (id) => {
    return await fetchWithAuth(URLS.GET_STATES_CITY_LIST(id), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const deleteAirlineAssociation = async (associationId) => {
    return await fetchWithAuth(
      URLS.DELETE_AIRLINE_ASSOCIATIONS(associationId),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const updateAirlineAssociation = async (airlineData) => {
    return await fetchWithAuth(URLS.UPDATE_AIRLINE_ASSOCIATIONS, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(airlineData),
    });
  };

  const fetchAviationStackAirlines = async () => {
    return await fetchWithAuth(URLS.GET_AVIATION_STACK_AIRLINES, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const getAviationStackFailure = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);
    return await fetchWithAuth(
      `${URLS.GET_AVIATION_STACK_FAILURE}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getAviationStackData = async (
    airlineId,
    month,
    year,
    pageNo,
    size,
    filters = {}
  ) => {
    const queryParams = new URLSearchParams();
    queryParams.append("month", month);
    queryParams.append("year", year);
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    // Add optional filters if they exist
    if (filters.arrivalAirportId) {
      queryParams.append("arrivalAirportId", filters.arrivalAirportId);
    }
    if (filters.departureAirportId) {
      queryParams.append("departureAirportId", filters.departureAirportId);
    }
    if (filters.aircraftTypeId) {
      queryParams.append("aircraftTypeId", filters.aircraftTypeId);
    }
    if (filters.flightDate) {
      queryParams.append("flightDate", filters.flightDate);
    }

    return await fetchWithAuth(
      `${URLS.GET_AVIATION_STACK_DATA(airlineId)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const bulkUpdateInvoices = async (flightPlanIds) => {
    return await fetchWithAuth(URLS.BULK_UPDATE_INVOICES, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(flightPlanIds),
    });
  };

  const getInvoices = async (
    userId,
    status,
    page,
    size,
    invoiceNumber,
    invoiceDate,
    invoiceDueDate
  ) => {
    const queryParams = new URLSearchParams({
      status: status,
      page: page.toString(),
      size: size.toString(),
    });

    if (invoiceDueDate) queryParams.append("invoiceDueDate", invoiceDueDate);
    if (invoiceDate) queryParams.append("invoiceDate", invoiceDate);
    if (invoiceNumber) queryParams.append("invoiceNumber", invoiceNumber);

    return await fetchWithAuth(
      `${URLS.GET_INVOICES(userId)}?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getInvoicesDetails = async (flightPlanId) => {
    return await fetchWithAuth(URLS.GET_INVOICE_DETAILS(flightPlanId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const searchCommercialAirlineProfile = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return await fetchWithAuth(
      `${URLS.SEARCH_COMMERCIAL_PROFILE}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const searchScannedPassengers = async (planId, searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(
      `${URLS.SEARCH_SCANNED_PASSENGERS(planId)}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const inviteCommercialUserProfile = async (userData) => {
    return await fetchWithAuth(URLS.INVITE_COMMERCIAL_USER, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });
  };
  const addDeviceToken = async (deviceToken) => {
    return await fetchWithAuth(
      `${URLS.ADD_DEVICE_TOKEN(isAAUser)}?deviceToken=${deviceToken}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const removeDeviceToken = async () => {
    return await fetchWithAuth(URLS.REMOVE_DEVICE_TOKEN(isAAUser), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchCommercialEscort = async (flightPlanId) => {
    return await fetchWithAuth(
      URLS.GET_COMMERCIAL_ESCORT(flightPlanId, isAAUser)
    );
  };

  const addCommercialEscort = async (escortData) => {
    return await fetchWithAuth(URLS.ADD_COMMERCIAL_ESCORT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(escortData),
    });
  };

  const updateCommercialEscort = async (escortData) => {
    return await fetchWithAuth(URLS.ADD_COMMERCIAL_ESCORT, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(escortData),
    });
  };

  const fetchEscortCommercialFlightPlans = async (filterData) => {
    const queryParams = new URLSearchParams({
      page: filterData.page || 0,
      size: filterData.size || 10,
      ...(filterData.arrivalAirportId && {
        arrivalAirportId: filterData.arrivalAirportId,
      }),
      ...(filterData.departureAirportId && {
        departureAirportId: filterData.departureAirportId,
      }),
      ...(filterData.airlineId && { airlineId: filterData.airlineId }),
      ...(filterData.departureDate && {
        departureDate: filterData.departureDate,
      }),
      ...(filterData.escortDepartureStatus && { escortDepartureStatuses: filterData.escortDepartureStatus }),
      ...(filterData.escortArrivalStatus && { escortArrivalStatuses: filterData.escortArrivalStatus }),
      ...(filterData.adsbVerified && { adsbVerified: filterData.adsbVerified }),
      ...(filterData.bmsVerified && { bmsVerified: filterData.bmsVerified }),
    }).toString();

    return await fetchWithAuth(
      `${URLS.GET_ESCORT_COMMERCIAL_FLIGHT_PLANS}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getEscortDetails = async (flightPlanId) => {
    return await fetchWithAuth(
      URLS.GET_ESCORT_DETAILS(flightPlanId, isAAUser),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const getOfficersByAirport = async (airportId) => {
    return await fetchWithAuth(`${URLS.GET_OFFICERS_BY_AIRPORT}/${airportId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const updateEscortOfficers = async (flightPlanId, officers, cfpPhase) => {
    const queryParams = new URLSearchParams({ cfpPhase: cfpPhase }).toString();
    return await fetchWithAuth(
      `${URLS.UPDATE_ESCORT_OFFICERS(flightPlanId)}?${queryParams}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(officers),
      }
    );
  };

  const approveEscortService = async (flightPlanId, escortData) => {
    return await fetchWithAuth(URLS.APPROVE_ESCORT_SERVICE(flightPlanId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(escortData),
    });
  };

  const rejectEscort = async (flightPlanId, escortData) => {
    return await fetchWithAuth(URLS.REJECT_ESCORT_SERVICE(flightPlanId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(escortData),
    });
  };

  const getProfileAssociation = async () => {
    return await fetchWithAuth(URLS.GET_PROFILE_ASSOCIATION, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const submitWireTransferPayment = async (paymentData) => {
    return await fetchWithAuth(URLS.WIRE_TRANSFER_PAYMENT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(paymentData),
    });
  };

  const fetchNotificationsUnreadCount = async () => {
    const queryParams = new URLSearchParams({
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.GET_NOTIFICATIONS_UNREAD_COUNT}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const readAllNotifications = async () => {
    const queryParams = new URLSearchParams({
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();

    return await fetchWithAuth(
      `${URLS.READ_ALL_NOTIFICATIONS}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchAllNotifications = async (data) => {
    const queryParams = new URLSearchParams({
      ...data,
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
      platformType: PLATFORM_TYPE,
    }).toString();
    return await fetchWithAuth(`${URLS.GET_All_NOTIFICATIONS}?${queryParams}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  };

  const readNotifications = async (notificationId) => {
    const queryParams = new URLSearchParams({
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.READ_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const unreadNotification = async (notificationId) => {
    const queryParams = new URLSearchParams({
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.UNREAD_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const deleteNotification = async (notificationId) => {
    const queryParams = new URLSearchParams({
      platformProfileType: isAAUser
        ? PLATFORM_PROFILE_AA_TYPE
        : PLATFORM_PROFILE_TYPE,
    }).toString();
    return await fetchWithAuth(
      `${URLS.DELETE_NOTIFICATION(notificationId)}?${queryParams}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const deleteEscortService = async (flightPlanId) => {
    return await fetchWithAuth(
      URLS.DELETE_ESCORT_SERVICE(flightPlanId, isAAUser),
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchIATAInvoices = async (airlineId, invoiceData) => {
    const queryParams = new URLSearchParams(invoiceData).toString();
    return await fetchWithAuth(
      `${URLS.GET_IATA_INVOICES(airlineId)}?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchIATAInvoicesBillingBreakdown = async (billingDocument) => {
    return await fetchWithAuth(
      URLS.GET_IATA_INVOICES_BILLING_BREAKDOWN(billingDocument),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchCommercialFlightPlansFeeInvoice = async (lineItemId, params) => {
    const queryParams = new URLSearchParams(params).toString();
    return await fetchWithAuth(
      `${URLS.GET_COMMERCIAL_FLIGHT_PLANS_INVOICE(lineItemId)}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const fetchIATAInvoiceFlights = async (billingDocument) => {
    return await fetchWithAuth(
      URLS.GET_IATA_INVOICES_FLIGHTS(billingDocument),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const exportCommercialInvoiceDetails = async (invoiceNumber, feeType) => {
    const queryParams = new URLSearchParams({
      invoiceNumber,
      feeType,
    }).toString();
    return await fetchWithAuth(
      `${URLS.EXPORT_COMMERCIAL_INVOICE_DETAILS}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const exportVendorLeaseInvoiceDetails = async (invoiceId) => {
    const queryParams = new URLSearchParams({ invoiceId }).toString();
    return await fetchWithAuth(
      `${URLS.EXPORT_VENDOR_LEASE_INVOICE_DETAILS}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const getBankConfig = async (env) => {
    return await fetchWithAuth(URLS.GET_BANK_CONFIG(env), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const getAirlineById = async (airlineId) => {
    return await fetchWithAuth(URLS.GET_AIRLINE_BY_ID(airlineId), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const getConcessionFee = async (
    airlineId,
    dynamicsCustomerNumber,
    submissionDate,
    page,
    size
  ) => {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });

    if (airlineId) {
      queryParams.append("airlineId", airlineId);
    }
    if (dynamicsCustomerNumber) {
      queryParams.append("dynamicsCustomerNumber", dynamicsCustomerNumber);
    }
    if (submissionDate) {
      queryParams.append("submissionDate", submissionDate);
    }

    return await fetchWithAuth(
      `${URLS.GET_CONCESSION_FEE(isAAUser)}?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const fetchAirlineVendorLease = async (leaseId, page = 0, size = 10) => {
    return await fetchWithAuth(
      URLS.GET_AIRLINE_VENDOR_LEASE(leaseId, page, size),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const updateAirlinePassengerCount = async (planId, disputeData) => {
    return await fetchWithAuth(URLS.UPDATE_AIRLINE_PASSENGER_COUNT(planId), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(disputeData),
    });
  };
  const updateDisputePassengerCount = async (planId, disputeData) => {
    return await fetchWithAuth(URLS.UPDATE_DISPUTE_PASSENGER_COUNT(planId), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(disputeData),
    });
  };

  const fetchConfiguration = async () => {
    const profile = "prod";

    return await fetchWithAuth(URLS.GET_CONFIG(profile), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchPassengerDispute = async (disputeData) => {
    const queryParams = new URLSearchParams(disputeData).toString();
    return await fetchWithAuth(
      `${URLS.GET_PASSENGER_DISPUTE(isAAUser)}?${queryParams}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  };

  const rejectDispute = async (disputeId) => {
    return await fetchWithAuth(URLS.REJECT_DISPUTE(disputeId), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const acceptDispute = async (disputeId) => {
    return await fetchWithAuth(URLS.ACCEPT_DISPUTE(disputeId), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const acceptAAPassengerCount = async (disputeId) => {

    return await fetchWithAuth(URLS.ACCEPT_AA_PASSENGER_COUNT(disputeId), {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    });
  };
  const acceptAirlinePassengerCount = async (disputeId) => {


    return await fetchWithAuth(URLS.ACCEPT_AIRLINE_PASSENGER_COUNT(disputeId), {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    });
  };

  const downloadCommercialInvoiceDetails = async (dynamicsInvoiceId) => {
    const url = URLS.DOWNLOAD_VAT_COMPLIANT_INVOICE(dynamicsInvoiceId);
    const fileName = `invoice-${dynamicsInvoiceId}.pdf`;
    return await downloadFileWithAuth(url, fileName);
  };
  return {
    fetchCommercialUserProfile,
    fetchHistoricCommercialFlightPlans,
    filterHistoricCommercialFlightPlans,
    fetchCommercialFlightPlans,
    fetchCommercialFlightPlan,
    filterCommercialFlightPlans,
    fetchCommercialFlightPlanFee,
    fetchCommercialFlightPlanApprovals,
    fetchListOfAirport,
    fetchAARoles,
    fetchListOfAirline,
    fetchListOfAssociatedAirline,
    fetchListOfAircraft,
    searchAircraft,
    searchAirport,
    fetchAircraftDetails,
    createCommercialFlightPlan,
    checkOvertimeFee,
    editCommercialFlightPlan,
    cancelCommercialFlightPlan,
    approveAACommercialFlightPlan,
    approveAirlineCommercialFlightPlan,
    checkAirlineApprovalDispute,
    editCommercialFlightPlanPassengers,
    editCommercialFlightPlanVehicles,
    searchFlightPlan,
    getAirlineAssociation,
    getAllCommercialAirline,
    searchAirline,
    fetchListOfCountry,
    fetchStateCityList,
    deleteAirlineAssociation,
    updateAirlineAssociation,
    fetchAviationStackAirlines,
    getAviationStackFailure,
    getAviationStackData,
    bulkUpdateInvoices,
    getInvoices,
    getInvoicesDetails,
    searchCommercialAirlineProfile,
    searchScannedPassengers,
    inviteCommercialUserProfile,
    addDeviceToken,
    removeDeviceToken,
    fetchCommercialEscort,
    addCommercialEscort,
    fetchEscortCommercialFlightPlans,
    updateCommercialEscort,
    getEscortDetails,
    getOfficersByAirport,
    updateEscortOfficers,
    approveEscortService,
    rejectEscort,
    getProfileAssociation,
    submitWireTransferPayment,
    fetchNotificationsUnreadCount,
    readAllNotifications,
    fetchAllNotifications,
    readNotifications,
    unreadNotification,
    deleteNotification,
    deleteEscortService,
    fetchIATAInvoices,
    fetchIATAInvoicesBillingBreakdown,
    fetchCommercialFlightPlansFeeInvoice,
    fetchIATAInvoiceFlights,
    exportCommercialInvoiceDetails,
    exportVendorLeaseInvoiceDetails,
    getBankConfig,
    getAirlineById,
    fetchCommercialFutureFlightPlans,
    filterCommercialFutureFlightPlans,
    fetchCommercialCurrentFlightPlansSummary,
    filterCommercialCurrentFlightPlansSummary,
    getConcessionFee,
    fetchAirlineVendorLease,
    updateAirlinePassengerCount,
    fetchPassengerDispute,
    rejectDispute,
    acceptDispute,
    updateDisputePassengerCount,
    fetchConfiguration,
    acceptAAPassengerCount,
    acceptAirlinePassengerCount,
    fetchAirportById,
    downloadCommercialInvoiceDetails
  };
};

export default useAirlineAdminApi;
